"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var table = document.querySelector("table");
var headers = table.querySelectorAll("th");
var tbody = table.querySelector("tbody");
var sortDirection = true;
var currentColumn = null;
headers.forEach(function(th, index) {
    th.addEventListener("click", function() {
        var _tbody;
        if (currentColumn === index) sortDirection = !sortDirection;
        else {
            sortDirection = true;
            currentColumn = index;
        }
        var rows = Array.from(tbody.querySelectorAll("tr"));
        rows.sort(function(a, b) {
            var aText = a.children[index].textContent;
            var bText = b.children[index].textContent;
            if (index === 4) {
                aText = Number(aText.replace(/[$,]/g, ""));
                bText = Number(bText.replace(/[$,]/g, ""));
            }
            if (!isNaN(aText)) aText = Number(aText);
            if (!isNaN(bText)) bText = Number(bText);
            if (aText > bText) return sortDirection ? 1 : -1;
            if (aText < bText) return sortDirection ? -1 : 1;
            return 0;
        });
        (_tbody = tbody).append.apply(_tbody, _to_consumable_array(rows));
    });
});
tbody.addEventListener("click", function(e) {
    var row = e.target.closest("tr");
    if (!row) return;
    tbody.querySelectorAll("tr").forEach(function(tr) {
        return tr.classList.remove("active");
    });
    row.classList.add("active");
});
var form = document.createElement("form");
form.className = "new-employee-form";
form.innerHTML = '\n  <label>Name: <input data-qa="name" name="name" type="text"></label>\n  <label>Position: <input data-qa="position" name="position" type="text"></label>\n  <label>Office:\n    <select data-qa="office" name="office">\n      <option>Tokyo</option>\n      <option>Singapore</option>\n      <option>London</option>\n      <option>New York</option>\n      <option>Edinburgh</option>\n      <option>San Francisco</option>\n    </select>\n  </label>\n  <label>Age: <input data-qa="age" name="age" type="number"></label>\n  <label>Salary: <input data-qa="salary" name="salary" type="number"></label>\n  <button type="submit">Save to table</button>\n';
document.body.append(form);
function showNotification(message, type) {
    var div = document.createElement("div");
    div.className = "notification ".concat(type);
    div.dataset.qa = "notification";
    div.textContent = message;
    document.body.append(div);
    setTimeout(function() {
        div.style.display = "none";
    }, 2000);
}
form.addEventListener("submit", function(e) {
    e.preventDefault();
    var userName = form.name.value.trim();
    var position = form.position.value.trim();
    var office = form.office.value;
    var age = Number(form.age.value);
    var salary = Number(form.salary.value);
    if (!userName || !position || !age || !salary) {
        showNotification("All fields are required", "error");
        return;
    }
    if (userName.length < 4) {
        showNotification("Name too short", "error");
        return;
    }
    if (age < 18 || age > 90) {
        showNotification("Invalid age", "error");
        return;
    }
    var formattedSalary = "$".concat(salary.toLocaleString("en-US"));
    var row = document.createElement("tr");
    row.innerHTML = "\n    <td>".concat(userName, "</td>\n    <td>").concat(position, "</td>\n    <td>").concat(office, "</td>\n    <td>").concat(age, "</td>\n    <td>").concat(formattedSalary, "</td>\n  ");
    tbody.append(row);
    showNotification("Employee added!", "success");
    form.reset();
});

//# sourceMappingURL=index.1fa4d22d.js.map
